import Candles from './Candles';
import PositiveValues from './PositiveValues';
import NegativeValues from './NegativeValues';
import Renko from './Renko';
import TimeRenko from './TimeRenko';
import TestLogic from './TestLogic';
import PositiveTimeLength from './PositiveTimeLength';
import NegativeTimeLength from './NegativeTimeLength';
import FakeTrader from './FakeTrader';
import LogCandle from './LogCandle';
import RenkoCounter from './RenkoCounter';

export default {
  Candles,
  PositiveValues,
  NegativeValues,
  Renko,
  TimeRenko,
  TestLogic,
  PositiveTimeLength,
  NegativeTimeLength,
  FakeTrader,
  LogCandle,
  RenkoCounter,
};
